import { useState } from "react";
import { MoreVertical, LogOut, Settings, Shield, Bug } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { supabase } from "@/integrations/supabase/client";
import databullLogo from "@/assets/databulllogo.png";
import { APP_NAME } from "@/lib/brand";
import IssueDialog from "@/components/IssueDialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const MobileHeader = () => {
  const { user, profile, clientInfo } = useAuth();
  const navigate = useNavigate();
  const [issueDialogOpen, setIssueDialogOpen] = useState(false);

  return (
    <header className="flex h-14 items-center justify-between border-b border-border bg-card px-4 z-50 fixed top-0 left-0 right-0">
      <a href="/research" className="flex items-center gap-2 cursor-pointer">
        <img src={clientInfo?.logo_url || databullLogo} alt={APP_NAME} className="h-8 w-8 rounded-lg object-cover shrink-0" />
        <div className="flex flex-col">
          <span className="text-lg font-bold tracking-tight text-foreground leading-tight">{APP_NAME}</span>
          {clientInfo?.name && (
            <span className="text-xs text-muted-foreground leading-tight">{clientInfo.name}</span>
          )}
        </div>
      </a>

      {user && (
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-foreground truncate max-w-[120px]">
            {profile?.full_name || user.email?.split("@")[0]}
          </span>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="icon" className="h-8 w-8 text-muted-foreground shrink-0">
                <MoreVertical className="h-4 w-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-48 bg-popover z-50">
              {profile?.admin && (
                <DropdownMenuItem onClick={() => navigate("/admin")}>
                  <Settings className="h-4 w-4 mr-2" />
                  Admin
                </DropdownMenuItem>
              )}
              {profile?.super_admin && (
                <DropdownMenuItem onClick={() => navigate("/superadmin")}>
                  <Shield className="h-4 w-4 mr-2" />
                  Super Admin
                </DropdownMenuItem>
              )}
              {(profile?.admin || profile?.super_admin) && <DropdownMenuSeparator />}
              <DropdownMenuItem onClick={() => setIssueDialogOpen(true)}>
                <Bug className="h-4 w-4 mr-2" />
                Report Issue
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={() => supabase.auth.signOut()}>
                <LogOut className="h-4 w-4 mr-2" />
                Sign out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      )}

      <IssueDialog open={issueDialogOpen} onOpenChange={setIssueDialogOpen} />
    </header>
  );
};

export default MobileHeader;
